import client from './oc2api';

type Params = {
  event_id: number;
  schedule_id: number;
};

export type EntryParams = {
  eventId: number;
  scheduleId: number;
};


export function sendEntryRequest(params: EntryParams) {
  return client
    .post('/api/v1/entries', {
      event_id: params.eventId,
      schedule_id: params.scheduleId,
      client_type: 'web',
    })
    .then((response) => {
      if (response.status !== 201) {
        throw 'Unexpected status';
      }
    });
}
